import React from "react";
import styles from "./login.module.css";
import economicLogo from "@/assets/img/economicLogo.svg";

const NavbarLogin = () => {
  return (
    <div className={styles.navbarLogin}>
      <div className={styles.navbarLogoWrapper}>
        <img
          src="/assets/logo-white.svg"
          width={"120.51px"}
          height={"24px"}
          alt="cloudeqImage"
        />
        <span className={styles.seperator}></span>
        <img src={economicLogo} alt="" width={"120.51px"} height={"24px"}></img>
      </div>
    </div>
  );
};

export default NavbarLogin;
